import Vue from 'vue';
import moment from 'moment';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import { PlaybookAuth } from '@/plugins/gAuth';
import config from '@/auth/g_oauth_config.json';

Vue.config.productionTip = false;

Vue.use(PlaybookAuth, { ...config });
Vue.use(require('vue-moment'), { moment });

new Vue({
  router,
  store,
  vuetify,
  beforeCreate() { this.$store.commit('initialiseStore'); },
  render: (h) => h(App)
}).$mount('#app');
